import React, { useState, useEffect, useRef } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import profileImg from "../../assets/images/profile-img.png"
import LabelChargeData from "../../components/Common/labelChargeData"
//i18n
import { useTranslation } from "react-i18next"
//redux
import { useDispatch, useSelector } from "react-redux"
import { initLoadUserData } from "../../store/actions"

const WelcomeComp = () => {
  const { t } = useTranslation()
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  const [avatar, setAvatar] = useState()
  const dispatch = useDispatch()

  const { loading, currentUser } = useSelector(state => ({
    loading: state.Dashboard.loading,
    currentUser: state.Dashboard.user,
  }))

  useEffect(() => {
    import(
      "assets/images/" + process.env.REACT_APP_STYLE_TEMPLATE + "/avatar.svg"
    ).then(setAvatar)
  }, [])
  useEffect(() => {
    loadData()
  }, [auth])

  const loadData = async () => {
    if (auth) {
      const request = {
        username: auth.id.user.username,
      }
      await dispatch(initLoadUserData(request))
    }
  }
  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary bg-soft">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">{t("dashboard:welcome")}</h5>
                <p>{t("global:title")}</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  src={avatar?.default}
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
              {currentUser?.supplier ? (
                <span>
                  <h5 className="font-size-13 text-uppercase">
                    {currentUser?.supplier?.name}
                  </h5>
                </span>
              ) : null}
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col>
                    <LabelChargeData
                      label={""}
                      showloading={!currentUser}
                      title={t("global:loading")}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <h5 className="font-size-14  text-uppercase">
                      {currentUser?.name}
                    </h5>
                    <p className="text-muted mb-0  text-uppercase">
                      {currentUser?.positionWork}
                    </p>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Link
                    to="/account_status"
                    className="btn btn-primary  btn-sm"
                  >
                    {t("dashboard:Statement")}
                    <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp
